module.exports = __webpack_public_path__ + "img/defaultImg.7879bcca.png";